import gql from "graphql-tag";

export const UPSERT_USER_TODO_MUTATION = gql`
mutation upsertUserTodoMutation($data: UserTodoInput!){
  upsertUserTodoMutation(data: $data){
    error
    success
  }
}`